import { CHARGING_CARDS_CHARACTER_LIMIT } from '@/lib/constants';
import { t } from '@/lib/utils';

const DEFAULT_CARD_NUMBER = 12345;

interface CardLineProps {
    content?: string;
    defaultText: string;
}
const CardLine = ({ content, defaultText }: CardLineProps) => {
    const isContentEmpty = !content || content.trim() === '';
    const displayText = isContentEmpty ? defaultText : content.substring(0, CHARGING_CARDS_CHARACTER_LIMIT);
    return (
        <span className={`height-20pct ${isContentEmpty ? 'text-color-gray' : 'text-color-white'}`}>{displayText}</span>
    );
};

interface CardPreviewProps {
    line1?: string;
    line2?: string;
    number?: number;
    showDefaultText?: boolean;
}

export const CardPreview = ({
    line1 = '',
    line2 = '',
    number = DEFAULT_CARD_NUMBER,
    showDefaultText = true,
}: CardPreviewProps) => (
    <div
        className='display-flex bg-size-cover height-150'
        style={{
            backgroundImage: `url('/cardPreview.svg')`,
            width: '238px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
        role='img'
        aria-label='Card Preview'
    >
        <div className='display-flex padding-top-50 flex-column width-100pct gap-5 padding-x-15 padding-bottom-10 overflow-hidden'>
            <CardLine content={line1} defaultText={showDefaultText ? `${t('onboarding.printedLine')} 1` : ''} />
            <CardLine content={line2} defaultText={showDefaultText ? `${t('onboarding.printedLine')} 2` : ''} />
            <span className='display-flex flex-1-1-0 align-items-end justify-content-end text-color-white '>
                {number}
            </span>
        </div>
    </div>
);
